import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAPublicAdministrationCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Public Administration",
    shortName: "B.A. Public Administration",
    duration: "3 years",
    description: "Study of government administration, policy implementation, and public service management",
    overview: "Bachelor of Arts in Public Administration is a 3-year undergraduate program that focuses on the management and administration of government organizations and public sector institutions. This course covers public policy, governance, administrative theory, and public service delivery, preparing students for careers in government services, public sector management, and policy analysis.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Interest in governance and public service",
      "Good communication and leadership skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Public Administration",
          "Principles of Management",
          "Indian Constitution",
          "General English",
          "Political Science",
          "Economics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Administrative Theory",
          "Public Policy Analysis",
          "Human Resource Management",
          "Financial Administration",
          "Local Government",
          "Development Administration"
        ]
      },
      {
        year: 3,
        subjects: [
          "Comparative Public Administration",
          "Administrative Law",
          "E-Governance",
          "Social Welfare Administration",
          "Research Methods",
          "Internship Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Civil Services Officer (IAS/IPS/IFS)",
        "Administrative Officer",
        "Policy Analyst",
        "Public Relations Officer",
        "Municipal Administrator",
        "Development Officer",
        "Research Associate",
        "Government Consultant",
        "NGO Administrator",
        "Corporate Affairs Manager"
      ],
      industries: [
        "Central Government",
        "State Government",
        "Local Government Bodies",
        "Public Sector Undertakings",
        "International Organizations",
        "NGOs and NPOs",
        "Consulting Firms",
        "Research Institutes",
        "Corporate Public Affairs",
        "Educational Institutions"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹12-30 LPA (Experienced)",
      topRecruiters: [
        "UPSC, TNPSC, SSC",
        "Municipal Corporations",
        "Public Sector Banks",
        "UNDP, World Bank",
        "McKinsey, Deloitte",
        "Government Departments"
      ]
    },

    admissionProcess: [
      "Merit-based admission on 12th marks",
      "University entrance examinations",
      "Interview process in select colleges",
      "Online application and counseling",
      "Document verification"
    ],

    topColleges: [
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹25,000",
        ranking: "State University"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹30,000",
        ranking: "State University"
      },
      {
        name: "Bharathidasan University",
        location: "Tiruchirappalli",
        fees: "₹28,000",
        ranking: "State University"
      },
      {
        name: "Madurai Kamaraj University",
        location: "Madurai",
        fees: "₹26,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Public Policy Analysis",
      "Administrative Skills",
      "Leadership and Management",
      "Communication Skills",
      "Research and Analysis",
      "Problem Solving",
      "Project Management",
      "Negotiation Skills",
      "Team Building",
      "Digital Governance"
    ],

    futureScope: "Excellent growth opportunities with digital governance initiatives, policy reforms, smart city projects, and increasing focus on efficient public service delivery.",

    faqs: [
      {
        question: "What is the scope of B.A. Public Administration for civil services?",
        answer: "Public Administration is an excellent foundation for civil services preparation, providing deep understanding of governance, policy, and administrative processes required for IAS/IPS/IFS."
      },
      {
        question: "Can I work in private sector after this course?",
        answer: "Yes, skills in administration, policy analysis, and management are valuable in corporate public affairs, consulting, CSR, and government relations roles."
      },
      {
        question: "What are the research opportunities in this field?",
        answer: "Research opportunities exist in policy think tanks, academic institutions, international organizations, and government research bodies focusing on governance and public policy."
      },
      {
        question: "Is this course suitable for entrepreneurship?",
        answer: "Yes, understanding of government processes, policy frameworks, and public-private partnerships provides strong foundation for social entrepreneurship and consulting businesses."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAPublicAdministrationCoursePage;
